import { FormControl, InputLabel, MenuItem, Select } from "@mui/material"
import { LocalizedEnum, LocalizedStrict } from "../../../../modules/localization/components/AppLocalized"
import { iterateStringEnum } from "../../../../lib/enums"

export enum DateType {
    ORDER_DATE = "ORDER_DATE",
    DELIVERY_DATE = "DELIVERY_DATE",
}

type SelectDateTypeFilterProps = {
    dateType: DateType
    setDateType: (val: DateType) => void
    className?: string
    inputLabelClasses?: string
}

export function SelectDateTypeFilter({
    dateType,
    setDateType,
    className,
    inputLabelClasses,
}: SelectDateTypeFilterProps) {
    return (
        <FormControl sx={{ minWidth: "13rem" }}>
            <LocalizedStrict id="table-select-data-type-filter-on-label">
                <InputLabel id="supplier-pos-table-select-filter">Filter on</InputLabel>
            </LocalizedStrict>
            <LocalizedStrict id="table-select-data-type-filter-on-label-label" attrs={{ label: true }}>
                <Select
                    labelId="supplier-pos-table-select-filter"
                    id="supplier-pos-table-select-filter-on"
                    value={dateType}
                    label="Filter on"
                    onChange={(e) => setDateType(e.target.value as DateType)}
                    className={className}
                >
                    {[...iterateStringEnum(DateType)].map((value) => (
                        <MenuItem key={value} value={value}>
                            <LocalizedEnum base="table-select-data-type-filter-on-item" enumValue={value}>
                                <span>{value}</span>
                            </LocalizedEnum>
                        </MenuItem>
                    ))}
                </Select>
            </LocalizedStrict>
        </FormControl>
    )
}
